import Waitlist from "../services/Waitlist";
import Content from "../services/Content";
import Masks from "../services/Masks";

export default {

    props: ['siteId','intialValue'],

    data: () => { return {
        isLoading: false,
        isSubmitted: false,
        statesList: [],
        citiesList: [],
        citiesActiveList: [],
        error: null,
        response: {},
        masks: Masks,
        minDate:null,
        maxDate:null,
        today:null,
        validList: [],
        fields: [
            'nome',
            'email',
            'ddd-whatsapp',
            'whatsapp',
            'ddd-telefone',
            'telefone',
            'birthdate',
            'uf',
            'city'
        ]
    }},

    mounted: function() {
        if (this.intialValue !== undefined) {
            Object.keys(this.intialValue).forEach(function (item) {
                this.response[item] = this.intialValue[item];
            }.bind(this));
            this.$forceUpdate();
        }

        Content.GetStatesAndCities()
            .then((res) => {
                this.statesList = res.states;
                this.citiesList = res.cities;
            })
            .catch((err) => {

            });

        const now = new Date()
        this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

        // 15th two months prior
        this.minDate = new Date(this.today)
        this.minDate.setFullYear(this.today.getFullYear() - 91)

        // 15th in two months
        this.maxDate = new Date(this.today)
        this.maxDate.setFullYear(this.today.getFullYear() - 13)


        this.validList = this.fields;

    },

    methods: {
        onSubmit: function() {

            if(!this.validateFields()){
                return;
            }

            this.isLoading = true;
            this.response.siteid = this.siteId;

            Waitlist.Submit(this.formId, {response: this.response})
                .then((res) => {
                    this.isLoading = false;
                    this.isSubmitted = true;
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.error = err;
                })
        },
        onChangeUF: function () {

            let stateId = 1;

            for(let i = 0 ; i < this.statesList.length; i ++) {
                if (this.statesList[i].letter === this.response.uf) {
                    stateId = this.statesList[i].id;
                }
            }

            this.citiesActiveList = [];
            for(let i = 0 ; i < this.citiesList.length; i ++) {
                if (this.citiesList[i].state_id === stateId) {
                    this.citiesActiveList.push(this.citiesList[i]);
                }
            }
        },
        validateFields: function () {

            //document.getElementById('wait-list-form').classList.add('was-validated');

            this.validList = Object.values(this.fields);
            this.$forceUpdate();

            let errorCount = 0;
            Object.values(this.fields).forEach(function (item){
                if(this.response[item] === undefined || this.response[item] === '') {
                    this.validList.splice(this.validList.indexOf(item),1);
                    errorCount++;
                }
            }.bind(this));

            if (this.response['birthdate'] !== undefined) {
                let date = this.response['birthdate'];
                let dateCheck = date.split('/');
                let dateConvert = new Date(dateCheck[2],dateCheck[1],dateCheck[0]);

                if(dateConvert.getFullYear() > this.today.getFullYear() - 13 || dateConvert.getFullYear() < this.today.getFullYear() - 91) {
                    this.validList.splice(this.validList.indexOf('birthdate'),1);
                    errorCount++;
                }
            }

            if (this.response['email'] !== undefined) {
                let mail = this.response['email'];
                if (mail.indexOf('.') === -1) {
                    this.validList.splice(this.validList.indexOf('email'),1);
                    errorCount++;
                }
            }

            return errorCount === 0;

        }
    }

}
